import axios from 'axios';
import { useEffect, useState } from 'react';

const Footer = () => {
	const [footerContent, setFooterContent] = useState('');

	const footerFragment =
		'/content/experience-fragments/vizio/us/en/2022-footer/master/jcr:content/root.plain.html';

	useEffect(() => {
		axios.get(footerFragment).then((response) => {
			setFooterContent(response.data);
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return <div dangerouslySetInnerHTML={{ __html: footerContent }}></div>;
};

export default Footer;
